<template>
  <CContainer>
    <h3>Datos de Usuario</h3>
    <CCard class="mt-4 mb-1 p-3 col-sm-12">
      <CCardBody>
        <CForm class="p-2">
          <CRow>
            <CCol col="sm-6">
              <CInput 
                addLabelClasses="text-muted font-weight-bold"
                label="Usuario:" 
                required
                :value.sync="user.usuario"
                @blur="validate()">
              </CInput>
            </CCol>
            <CCol col="sm-6">
              <label class="text-muted font-weight-bold mt-1">Estado:</label>
              <CRow>
                <CCol>
                  <CSwitch
                    class="align-middle"
                    color="primary"
                    shape="pill"
                    variant="opposite"
                    :checked.sync="user.estado"
                  />
                  <span class="text-muted font-weight-bold ml-2">{{ user.estado ? "Activo" : "Inactivo" }}</span>              
                </CCol>
              </CRow>
            </CCol>
            <CCol col="sm-6">
              <CInput 
                label="Nombres:" 
                addLabelClasses="text-muted font-weight-bold"
                required
                :value.sync="user.nombres"
                @blur="validate()">
              </CInput>
            </CCol>
            <CCol col="sm-6">
              <CInput 
                label="Apellidos:" 
                addLabelClasses="text-muted font-weight-bold"
                required
                :value.sync="user.apellidos"
                @blur="validate()">
              </CInput>
            </CCol>
            <CCol col="sm-12">
              <CInput 
                label="Correo Electrónico:" 
                addLabelClasses="text-muted font-weight-bold"
                required
                :value.sync="user.correo_Electronico"
                @blur="validate()">
              </CInput>
            </CCol>
            <CCol col="sm-4">
              <CSelect 
                label="Tipo Usuario:" 
                addLabelClasses="text-muted font-weight-bold"
                required
                :options="typesUsers"
                :value.sync="user.tipo_Usuario"
                @change="() => {
                  user['id'] = ''
                  user['id_Empleado'] = null
                  user['id_Directorio'] = null
                  directory.length = 0
                  employees.length = 0

                  validate()
                }">
              </CSelect>
            </CCol>
            <CCol col="sm-12" v-if="user.tipo_Usuario === 'E'">
              <CAutocomplete 
                label="Empleado:" 
                required
                :options="employees"
                :value.sync="user['employee']"
                @update-search="value => getEmployeeData(value)"
                @update:input="(newValue) => {
                  user.id = newValue
                  user.id_Empleado = newValue
                  user.id_Directorio = null

                  validate()
                }">
              </CAutocomplete>
            </CCol>
            <CCol col="sm-4" v-if="user.tipo_Usuario === 'C'">
              <CSelect 
                label="Tipo Gestor:"
                addLabelClasses="text-muted font-weight-bold"
                :options="typesManagers"
                :value.sync="user.tipo_Gestor">
              </CSelect>
            </CCol>
            <CCol col="sm-4" v-if="user.tipo_Usuario === 'C'">
              <label class="text-muted font-weight-bold mt-1">Activa Autorizadores:</label>
              <CRow>
                <CCol>
                  <CSwitch
                    class="align-middle"
                    color="primary"
                    shape="pill"
                    variant="opposite"
                    :checked.sync="user.activa_Autorizadores"
                  />
                  <span class="text-muted font-weight-bold ml-2">{{ user.activa_Autorizadores ? "Activo" : "Inactivo" }}</span>              
                </CCol>
              </CRow>
            </CCol>
            <CCol col="sm-12" v-if="user.tipo_Usuario === 'C'">
              <CAutocomplete 
                label="Empresa:" 
                required
                :options="directory"
                :value.sync="user['directory']"
                @update-search="value => getDirectoryData(value)"
                @update:input="(newValue) => {
                  user.id = newValue
                  user.id_Directorio = newValue
                  user.id_Empleado = ''

                  validate()
                }">
              </CAutocomplete>
            </CCol>
          </CRow>
        </CForm>
      </CCardBody>
      <CCardFooter align="center">
        <CRow>
          <CCol>
            <CButton
              color="success"
              class="mr-2"
              :class="isValidForm ? '' : 'disabled'"
              :disabled="!isValidForm"
              @click="save()">
              <CIcon name="cil-check-alt"/>
              <span class="align-middle ml-2">Guardar</span>
            </CButton>
            <CButton
              color="danger"
              variant="outline"
              @click="$router.back()">
              <CIcon name="cil-x"/>
              <span class="align-middle ml-2">Cancelar</span>
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CElementCover v-show="loading"/>

    <CModal 
      title="Confirmacion" 
      color="danger" 
      size="sm" 
      centered 
      closeOnBackdrop 
      :show.sync="showModalConfirm">

    </CModal>
  </CContainer>
</template>

<script>
  import CONSTANTS from '../../constants'
  import CAutocomplete from '../containers/CAutocomplete'
  import { crudUsuario } from "@/apis/security";
  import {
    searchPersonal,
    searchDirectorio
  } from "../../apiDataSearch"

  export default {
    name: "UserForm",
    components:{
      CAutocomplete
    },
    data () {
      return {
          loading: false,
          isCreated: false,
          user: {
            usuario: "",
            nombres: "",
            apellidos: "",
            correo_Electronico: "",
            tipo_Usuario: "",
            id_Empleado: null,
            id_Directorio: null,
            estado: true,
            tipo_Gestor: "",
            activa_Autorizadores: false,
            id: ""
          },
          typesUsers: [
            {
              value: "",
              label: "Seleccionar"
            },
            {
              value: "C",
              label: "Cliente"
            },
            {
              value: "E",
              label: "Empleado"
            }
          ],
          typesManagers: [
            {
              value: "U",
              label: "Usuario"
            },
            {
              value: "S",
              label: "Supervisor"
            }
          ],
          directory: [],
          employees: [],
          groupValid: ["usuario", "nombres", "apellidos", "correo_Electronico", "tipo_Usuario", "id"],
          isValidForm: false
      }
    },
    beforeRouteEnter(to, from, next) {
      // console.log("before...");
      // console.log(to);
      // console.log(from);
      // console.log(next);

      next(vm => {
        vm.fromRoute = from
      })
    },
    methods:{
      async getEmployeeData(value) {
        if (value.length > 2) {
          try {
            const response = await searchPersonal(this, value)
            this.employees = response.map(item => {
              return {
                value: item.id_Personal,
                label: `${item.nombre_Empleado} - ${item.identificacion}`
              }
            })
          } catch(error) {
            this.$store.commit(
              "setAlert",
              {
                color: "danger",
                message: "Error al cargar los datos...",
                show: 5
              }
            )
          }
        }
      },
      async getDirectoryData(value) {
        if (value.length > 2) {
          try {
            const response = await searchDirectorio(this, value)
            this.directory = response.map(item => {
              return {
                value: item.id_Directorio,
                label: `${item.empresa} - ${item.identificacion}`
              }
            })
          } catch(error) {
            this.$store.commit(
              "setAlert",
              {
                color: "danger",
                message: "Error al cargar los datos...",
                show: 5
              }
            )
          }
        }
      },
      async getData(idUser) {
        this.loading = true
        
        try {
          return idUser
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async save(){
        this.loading = true

        try {
          this.user.estado = this.user.estado ? "A" : "I"
          this.user.activa_Autorizadores = this.user.activa_Autorizadores ? "V" : "F"
          this.user.tipo_Gestor = this.user.tipo_Gestor ? this.user.tipo_Gestor : null

          delete this.user["id"]

          const { errorCode, errorMessage } = await crudUsuario(this, "create", null, this.user)

          this.user.estado = true

          // const processData = {...this.dependency}
          // Object.keys(processData).forEach(key => {
          //   processData[key] ? null : delete processData[key]
          // })
          // processData['directorio'] = this.directory
          // if(this.create){
          //   await guardarDependencia(this, processData)
          // } else {          
          //   await actualizarDependencia(this, this.$store.state['selectedDependency'].id_Dependencia, processData)
          // }

          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: "Acción exitosa",
              show: 5
            })
          } else {
            this.$store.commit("setAlert", {
              color: "danger",
              message: errorMessage,
              show: 5
            })
          }

          this.$router.back()
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: this.create ? CONSTANTS.messages.notDoneAdd : CONSTANTS.messages.notDoneEdit,
            show: 5
          })
        } finally {
          this.loading = false
        }        
      },
      validate() {
        this.isValidForm = this.groupValid.reduce((acc, key) => {
          return acc && (this.user[key].length > 0)
        }, true)
      }
    }, 
    async mounted() {
      if (!this.$router.currentRoute.fullPath.includes("agregar")) {
        console.log("Under contruction...");
        // if (this.$store.state['selectedDependency']) {
        //   try {
        //     const dep = await this.getData(this.$store.state['selectedDependency'].id_Dependencia)
        //     this.dependencyLoaded = {...dep}
        //     Object.keys(this.dependency).forEach(key => {
        //         if (this.dependency[key] !== undefined) {
        //           //   console.log(key, dep[key])
        //           this.$set(this.dependency, key, dep[key])
        //           // this.dependency[key] = dep[key]
        //         }
        //     })
        //   } catch(error) {
        //     this.$store.commit('setAlert', {
        //     color: "danger",
        //     message: "Error al cargar datos",
        //     show: 5
        //   })
        //   }
        // } else {
        //   this.$router.back()
        // }        
      } else {
        this.isCreated = true

        this.validate()
      }
    }
  }
</script>